import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { Input, Label } from "reactstrap";
import {
  getGeneralM,
  getManager,
  getOutletM,
  getSeniorM,
  getVP,
} from "service/inentiveService";
import {
  ADMIN_DEFAULT_POSITION,
  POSITIONS,
  POSITIONS_LABEL,
  POSITION_HIERARCHY,
} from "constant/variables";
import { getIsAdmin } from "utils";

const currentHierarchy = () => {
  const isAdmin = getIsAdmin();
  const currentPosisition = isAdmin
    ? ADMIN_DEFAULT_POSITION
    : JSON.parse(localStorage.getItem("Position"));
  const newHierarchy = [...POSITION_HIERARCHY];
  const currentIndex = newHierarchy.indexOf(currentPosisition);
  const splitArr = newHierarchy.splice(currentIndex + 1, 5);
  return splitArr;
};

const getDefaultData = () => {
  const hierarchy = currentHierarchy();
  const data = {};
  hierarchy.forEach((h) => {
    data[h] = [];
  });
  return data;
};

const PositionFilters = (props, ref) => {
  const isAdmin = getIsAdmin();

  const OwnerPosition = isAdmin
    ? ADMIN_DEFAULT_POSITION
    : JSON.parse(localStorage.getItem("Position"));
  const client_id = JSON.parse(localStorage.getItem("clientId"));
  const [hierarchy] = useState(currentHierarchy());
  const [data, setData] = useState(getDefaultData());
  const [values, setValues] = useState({});

  const valuesRef = useRef({});
  const { month, year, channel } = props;

  useImperativeHandle(
    ref,
    () => ({
      getPositionClientId() {
        const values = valuesRef.current || {};
        let clientId = values[hierarchy[0]];
        if (values[hierarchy[4]]) {
          clientId = values[hierarchy[4]];
        } else if (values[hierarchy[3]]) {
          clientId = values[hierarchy[3]];
        } else if (values[hierarchy[2]]) {
          clientId = values[hierarchy[2]];
        } else if (values[hierarchy[1]]) {
          clientId = values[hierarchy[1]];
        }
        return clientId;
      },
      getSelectedPosition() {
        const values = valuesRef.current || {};
        let sp =
          hierarchy[0] && values[hierarchy[0]] ? hierarchy[0] : OwnerPosition;
        if (values[hierarchy[4]]) {
          sp = hierarchy[4];
        } else if (values[hierarchy[3]]) {
          sp = hierarchy[3];
        } else if (values[hierarchy[2]]) {
          sp = hierarchy[2];
        } else if (values[hierarchy[1]]) {
          sp = hierarchy[1];
        }
        console.log("PositionFilters getSelectedPosition", {
          values,
          sp,
          OwnerPosition,
          hierarchy,
        });
        return sp || OwnerPosition;
      },
      reset() {
        reset();
      },
    }),
    [hierarchy, OwnerPosition]
  );

  useEffect(() => {
    if (month && year) {
      dropDown();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [month, year]);

  const reset = () => {
    setValues({});
    valuesRef.current = {};
  };

  const updateData = (newData, position) => {
    const updatedData = { ...data };
    updatedData[position] = newData;
    setData(updatedData);
  };

  const dropDown = async (Position = OwnerPosition, clientId = client_id) => {
    if (Position === POSITIONS.VICE_PRESIDENT) {
      try {
        const res1 = await getVP(clientId, month, year);
        updateData(res1, POSITIONS.GENERAL_MANAGER);
      } catch (error) {
        console.log(error);
      }
    } else if (Position === POSITIONS.GENERAL_MANAGER) {
      try {
        const res1 = await getGeneralM(clientId, month, year);
        updateData(res1, POSITIONS.SENIOR_MANAGER);
      } catch (error) {
        console.log(error);
      }
    } else if (Position === POSITIONS.SENIOR_MANAGER) {
      try {
        const res1 = await getSeniorM(clientId, month, year);
        updateData(res1, POSITIONS.MANAGER);
      } catch (error) {
        console.log(error);
      }
    } else if (Position === POSITIONS.MANAGER) {
      try {
        const res1 = await getManager(clientId, month, year, channel);
        console.log("API CHANNEL ->>>>>>>>>>>>>>>>>>>", channel);
        updateData(res1, POSITIONS.OUTLET_MANAGER);
      } catch (error) {
        console.log(error);
      }
    } else if (Position === POSITIONS.OUTLET_MANAGER) {
      try {
        const res1 = await getOutletM(clientId, month, year);
        updateData(res1, POSITIONS.AGENT);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleChangeValue = (value, position, index) => {
    const newValues = { ...values };
    newValues[position] = value;
    setValues(newValues);
    valuesRef.current = newValues;
    if (hierarchy[index + 1]) {
      newValues[hierarchy[index + 1]] = undefined; // Reset Next Dropdown value
      updateData([], hierarchy[index + 1]); // Reset Next Dropdown Data
      if (value) {
        dropDown(position, value);
      }
    }
  };

  const renderDropdown = (title, data, value, onChange) => {
    return (
      <div className="col-12 mb-3">
        <div className="row">
          <Label>{title}</Label>
          <Input
            type="select"
            name="select"
            value={value || ""}
            className="form-control digits uiStyleDashboard"
            onChange={(e) => onChange(e.target.value)}
          >
            <option value="">{"Select"}</option>
            {data?.map((item) => (
              <option key={item.ID} value={item.ID}>
                {item.Name} - ({item.ID})
              </option>
            ))}
          </Input>
        </div>
      </div>
    );
  };

  return (
    <div className="col-12">
      {hierarchy.map((p, index) => {
        const dropdownData = data[p] || [];

        const outletName = POSITIONS.AGENT === p ? dropdownData[0]?.Outlet : "";
        const regionName =
          POSITIONS.OUTLET_MANAGER === p ? dropdownData[0]?.Region : "";

        const outlet = outletName ? `Select for ${outletName}` : "";
        const region = regionName ? `Select for ${regionName}` : "";

        return !index || values[hierarchy[index - 1]] ? (
          <div key={p}>
            {renderDropdown(
              `${props.t("Select")} ${POSITIONS_LABEL[p]} ${
                outletName ? `- ${outletName}` : ""
              }  ${regionName ? `- ${regionName}` : ""}`,
              data[p],
              values[p],
              (value) => handleChangeValue(value, p, index)
            )}
          </div>
        ) : null;
      })}
    </div>
  );
};

export default forwardRef(PositionFilters);
